"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var rx = require("rxjs");
var React = require("react");
var keautils_1 = require("keautils");
;
/**Convierte un valor a observable */
function toObservable(x) {
    if (keautils_1.isPromiseLike(x)) {
        return rx.Observable.fromPromise(x);
    }
    else if (keautils_1.isObservable(x)) {
        return x;
    }
    else {
        return rx.Observable.from([x]);
    }
}
function getIgnore(key, options) {
    var ignore = options && options[key] && options[key].ignore || {};
    return {
        promise: ignore.promise || false,
        observable: ignore.observable || false
    };
}
/**Indica si un prop se debe de ignorar según el valor del prop (que no sea promesa ni observable) o según la configuración (si el usuario indicó ignorar ese prop) */
function shouldIgnore(x, key, options) {
    var ignore = getIgnore(key, options);
    var prom = keautils_1.isPromiseLike(x);
    var obs = keautils_1.isObservable(x);
    return (!obs && !prom) || (prom && ignore.promise) || (obs && ignore.observable);
}
/**Devuelve true si todas las propiedades pasan como "ignore", es decir, que se deben de pasar tal cual al componente dibujado */
function allPropsIgnore(props, options) {
    var allProps = keautils_1.enumObject(props);
    return keautils_1.all(allProps, function (x) { return shouldIgnore(x.value, x.key, options); });
}
exports.allPropsIgnore = allPropsIgnore;
function renderComponentToRx(props, Component, Loading, Error, options, loadingDelayMs) {
    function getInitial(key) {
        return options && options[key] && options[key].initial;
    }
    function getLoadingProps(loading) {
        var filtrado = keautils_1.filterObject(options || {}, function (x) { return x && x.loading || false; });
        var map = keautils_1.mapObject(filtrado, function (x) { return loading; });
        return map;
    }
    function toObservableIgnore(x, key) {
        var ret = {
            ignore: shouldIgnore(x, key, options),
            obs: toObservable(x),
            original: x
        };
        return ret;
    }
    function ObsToPropValue(obs, key) {
        var loading = {
            value: getInitial(key),
            loading: true,
            error: undefined
        };
        var ret = obs
            .map(function (x) { return x == types_1.LoadingSym ? loading : {
            value: x,
            loading: false,
            error: undefined
        }; })
            .startWith(loading)
            .catch(function (err) { return [{
                value: undefined,
                loading: false,
                error: err
            }]; });
        return ret;
    }
    function obtenerError(values) {
        var arr = keautils_1.enumObject(values);
        var errores = arr.filter(function (x) { return x.value.error != null; });
        return errores.map(function (x) { return ({
            error: x.value.error,
            prop: x.key
        }); });
    }
    function estaCargando(values) {
        var arr = keautils_1.enumObject(values);
        var ret = keautils_1.any(arr, function (x) { return x.value.loading; });
        return ret;
    }
    function toPopValuesObs(obs) {
        var r = obs
            .scan(function (acc, value) {
            var last = acc.curr;
            var diff = keautils_1.shallowDiff(value, last);
            //Sólo recalculamos el ObsToPropValue de los observables que SI cambiaron
            var propValues = keautils_1.mapObject(value, function (val, key) {
                if (diff[key]) {
                    //Recalcular:
                    return ObsToPropValue(val, key);
                }
                else {
                    //Devolver el anterior:
                    return acc.propValues[key];
                }
            });
            var seed = {
                last: acc.curr,
                curr: value,
                diff: keautils_1.shallowDiff(value, acc.curr),
                propValues: propValues
            };
            return seed;
        }, {
            last: {},
            curr: {},
            diff: {}
        })
            .map(function (x) { return x.propValues; });
        return r;
    }
    function propValuesMapSwich(obs) {
        var ret = new rx.Observable(function (observer) {
            var last = {};
            var lastCombine = {};
            var subscriptions = {};
            var ret = obs.subscribe(function (current) {
                var e_1, _a, e_2, _b;
                var diff = keautils_1.shallowDiff(current, last);
                var diffKeys = keautils_1.enumObject(diff).map(function (x) { return x.key; });
                //Propiedades de las cuales se hay de desubscribir
                var currentKeys = Object.keys(current);
                var unsubscribeKeys = keautils_1.intersect(Object.keys(last), diffKeys);
                var subscribeKeys = keautils_1.intersect(currentKeys, diffKeys);
                last = current;
                function onInnerValue(key, value) {
                    var _a;
                    var newCombine = __assign({}, lastCombine, (_a = {}, _a[key] = value, _a));
                    //Quitamos del combine los props que no se encuentran en el current:
                    var filtered = keautils_1.filterObject(newCombine, function (value, key) { return keautils_1.contains(currentKeys, key); });
                    lastCombine = filtered;
                    //Checamos si el ultimo combine esta completo, en ese caso, emitimos el valor
                    var combineKeys = Object.keys(lastCombine);
                    var combineComplete = keautils_1.setEquals(currentKeys, combineKeys);
                    if (combineComplete) {
                        observer.next(lastCombine);
                    }
                }
                try {
                    //Quitamos las subscripciones anteriores
                    for (var unsubscribeKeys_1 = __values(unsubscribeKeys), unsubscribeKeys_1_1 = unsubscribeKeys_1.next(); !unsubscribeKeys_1_1.done; unsubscribeKeys_1_1 = unsubscribeKeys_1.next()) {
                        var k = unsubscribeKeys_1_1.value;
                        subscriptions[k].unsubscribe();
                        delete subscriptions[k];
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (unsubscribeKeys_1_1 && !unsubscribeKeys_1_1.done && (_a = unsubscribeKeys_1.return)) _a.call(unsubscribeKeys_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var _loop_1 = function (k) {
                    var newSub = current[k].subscribe(function (x) { return onInnerValue(k, x); });
                    subscriptions[k] = newSub;
                };
                try {
                    //Nos subscribimos a los nuevos props:
                    for (var subscribeKeys_1 = __values(subscribeKeys), subscribeKeys_1_1 = subscribeKeys_1.next(); !subscribeKeys_1_1.done; subscribeKeys_1_1 = subscribeKeys_1.next()) {
                        var k = subscribeKeys_1_1.value;
                        _loop_1(k);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (subscribeKeys_1_1 && !subscribeKeys_1_1.done && (_b = subscribeKeys_1.return)) _b.call(subscribeKeys_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
            return function () {
                //Quitar todas las subscripciones hijas:
                for (var k in subscriptions) {
                    subscriptions[k].unsubscribe();
                }
                ;
                ret.unsubscribe();
            };
        });
        return ret;
    }
    var propsAntesSwitch = props
        //Convertir todos los props a observable, asi ya no andamos manejando también promesas y valores sincronos.
        //El objeto resultante indica si se debe de ignorar, ignorar significa pasar el valor tal cual al componente final
        .map(function (props) { return keautils_1.mapObject(props, function (value, key) { return toObservableIgnore(value, key); }); })
        //Convertir todos los props a un observable del prop que se le debe de pasar, considerando los ignores del mapeo anterior
        .map(function (props) { return keautils_1.mapObject(props, function (prop) {
        //Si es ignore, se crea un observable a partir de ese valor
        return prop.ignore ? rx.Observable.from([prop.original]) : prop.obs;
    }); });
    var propsValues = toPopValuesObs(propsAntesSwitch);
    var propMapSwich = propValuesMapSwich(propsValues);
    var propsObs = 
    //En este punto tenemos un observable de objetos, donde cada propiedad es un 
    //observable de PropValue, y el prop value envuelve al valor del prop, ademas de a su valor inicial, si esta cargando/con error o no
    //Convertir los props de observables a un observable de los props 
    propMapSwich
        //Tenemos que agarrar el ultimo valor del prop antes de iniciar a cargar
        .scan(function (acc, value) { return keautils_1.mapObject(value, function (value, key) {
        var ret = {
            value: value.loading ? (acc[key] && acc[key].value) : value.value,
            error: value.error,
            loading: value.loading
        };
        return ret;
    }); }, {});
    ;
    //Observable con los JSX sin el debounce:
    var viewObsSinDeb = propsObs
        //Determinar si el componente tiene error y si esta cargando y extraer los props
        .map(function (x) { return ({
        props: keautils_1.mapObject(x, function (y) { return y.value; }),
        errores: obtenerError(x),
        cargando: estaCargando(x),
    }); })
        .scan(function (acc, value) { return (__assign({}, value, { first: acc.first == null })); }, {
        first: null,
    })
        .map(function (x) { return x; });
    var viewObs = keautils_1.debounceSync(viewObsSinDeb, function (x) {
        return (x.cargando && loadingDelayMs > 0) ? keautils_1.delay(loadingDelayMs) : keautils_1.syncResolve();
    })
        .map(function (x) { return (__assign({}, x, { props: __assign({}, x.props, getLoadingProps(x.cargando)) })); });
    var view = viewObs
        .map(function (x) {
        if (x.errores.length > 0) {
            return React.createElement(Error, { errores: x.errores });
        }
        else if (x.cargando) {
            return React.createElement(Loading, __assign({}, x.props));
        }
        else {
            return React.createElement(Component, __assign({}, x.props));
        }
    });
    return view;
}
exports.renderComponentToRx = renderComponentToRx;
/**Check if a value is a JSX.Element */
function isJsxElement(x) {
    return React.isValidElement(x);
}
exports.isJsxElement = isJsxElement;
//# sourceMappingURL=componentToRx.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-rxk/dist/componentToRx.js
// module id = 2505
// module chunks = 0